import React from 'react';
import { connect } from 'react-redux';
import style from './style.module.scss';
import Header from 'components/Header';
import MenuT from 'components/Menu';
import {Container} from 'react-bootstrap';

const MasterPage = WrappedComponent => {
  return connect(
    state => ({
      enlarged: state.menu_enlarged
    }),
    dispatch => ({
      setEnlarged: payload => dispatch({ type: 'MENU_ENLARGED', payload })
    })
  )(props => {
    const classEnlarged = props.enlarged ? ' enlarged' : '';

    return (
      <div className={style.layout}>
        <Header
          className={classEnlarged}
          enlarged={props.enlarged}
          setEnlarged={props.setEnlarged}
        />
        <MenuT className={classEnlarged} setEnlarged={props.setEnlarged}/>
        <div className={style.content_page + classEnlarged}>
          <Container>
          <WrappedComponent {...props} />
          </Container>
        </div>
      </div>
    );
  });
};

export default MasterPage;
